import { TAGSvgIcon } from '@aspendental/shared-components-web';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Box, Chip, Typography } from '@mui/material';
import { format } from 'date-fns';
import { useRef, useState } from 'react';
import { Swiper as SwiperType } from 'swiper';
// eslint-disable-next-line import/no-unresolved
import { Swiper, SwiperSlide } from 'swiper/react';
import { timeSlotsSwiperChipTimeStyles, timeslotsSwiperTimeslotCheckIconStyles, timeslotsSwiperWrapperStyles } from './TimeSlotsSwiper.styles';
import { ZenotiTimeslot } from '@src/lib/types';
type TimeSlotsSwiperProps = {
  slots: ZenotiTimeslot[];
  selectedTimeslot: string | null;
  isStepDisabled: boolean;
  handleTimeslotChange: (timeslot: string) => void;
};
export const TimeSlotsSwiper = ({
  slots,
  selectedTimeslot,
  isStepDisabled,
  handleTimeslotChange
}: TimeSlotsSwiperProps) => {
  const swiperRef = useRef<SwiperType | null>(null);
  const [isFirstStep, setIsFirstStep] = useState(true);
  const [isLastStep, setIsLastStep] = useState(false);
  return <Box sx={timeslotsSwiperWrapperStyles} data-sentry-element="Box" data-sentry-component="TimeSlotsSwiper" data-sentry-source-file="TimeSlotsSwiper.tsx">
			<TAGSvgIcon cursor="pointer" style={{
      minWidth: 'min-content',
      opacity: isFirstStep || isStepDisabled ? 0.5 : 1
    }} icon="ChevronLeftFunc" onClick={() => {
      if (!swiperRef!.current?.animating) {
        swiperRef.current?.slidePrev();
      }
      setIsFirstStep(swiperRef.current!.isBeginning);
      setIsLastStep(swiperRef.current!.isEnd);
    }} data-sentry-element="TAGSvgIcon" data-sentry-source-file="TimeSlotsSwiper.tsx" />
			<Swiper onSliderMove={() => {
      setIsFirstStep(swiperRef.current!.isBeginning);
      setIsLastStep(swiperRef.current!.isEnd);
    }} onSwiper={swiper => {
      swiperRef.current = swiper;
    }} slidesPerView="auto" spaceBetween={16} grabCursor style={{
      maskImage: `linear-gradient(90deg,transparent 0,#000 ${isFirstStep ? '0%' : '10%'},#000 ${isLastStep ? '100%' : '90%'},transparent)`,
      overflow: 'hidden'
    }} data-sentry-element="Swiper" data-sentry-source-file="TimeSlotsSwiper.tsx">
				{slots?.map(timeslot => {
        const startTime = format(new Date(timeslot.Time), 'hh:mmaaa');
        const isTimeslotSelected = selectedTimeslot === timeslot.Time;
        const chipIcon = isTimeslotSelected ? <CheckCircleIcon sx={timeslotsSwiperTimeslotCheckIconStyles} /> : undefined;
        const chipVariant = isTimeslotSelected ? 'selected' : 'default';
        return <SwiperSlide key={timeslot.Time} style={{
          width: '110px'
        }}>
							<Chip disabled={isStepDisabled} label={<Typography variant="bodyLargeBook">{startTime}</Typography>} variant={chipVariant} clickable icon={chipIcon} onClick={() => handleTimeslotChange(timeslot.Time)} sx={timeSlotsSwiperChipTimeStyles} />
						</SwiperSlide>;
      })}
			</Swiper>
			<TAGSvgIcon cursor="pointer" icon="ChevronRightFunc" style={{
      minWidth: 'min-content',
      opacity: isLastStep || isStepDisabled ? 0.5 : 1
    }} onClick={() => {
      if (!swiperRef!.current?.animating) {
        swiperRef.current?.slideNext();
      }
      setIsFirstStep(swiperRef.current!.isBeginning);
      setIsLastStep(swiperRef.current!.isEnd);
    }} data-sentry-element="TAGSvgIcon" data-sentry-source-file="TimeSlotsSwiper.tsx" />
		</Box>;
};